import React from 'react';
import { Helmet } from 'react-helmet';

function Onboarding_FAQ_Seo() {
    return (
        <div>
            <Helmet>
                <title>FinestPay on the App Store | FinestPay on the Play Store | FinestPay</title>
                <meta name="description" content="FinestPay: Download the FinestPay app from the App Store and Play Store. Seamlessly send money with ease and convenience. Enjoy secure and reliable money transfer services at your fingertips." />
                <meta property="og:title" content="FinestPay on the App Store | FinestPay on the Play Store | FinestPay" />
                <meta property="og:description" content="FinestPay: Download the FinestPay app from the App Store and Play Store. Seamlessly send money with ease and convenience. Enjoy secure and reliable money transfer services at your fingertips." />
                <meta property="og:image" content="https://finestpay.co.uk/assets/img/FinestPay-icon.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://finestpay.co.uk/onboarding-faq"/>
            </Helmet>
        </div>
    )
}

export default Onboarding_FAQ_Seo
